export default __webpack_public_path__ + "static/media/The Three Fangs of Reckoning.679a420b.jpg";